export const TITLE = 'The job is complete & signed-off';

export const INTRODUCED_TITLE = 'The order is complete & signed-off';

export const HEADER = "You'll receive updates here and via email.";

export const SUBTITLE_ARRAY = [
  'Your finance agreement is now in place, and ',
  '$partner',
  " will be paid out within the next 3 business days. You don't need to do anything else, we'll take it from here!",
];

export const LINE_1 = [
  'If you have questions about your loan, you can reach out to us at ',
  ' or your lender, $lender, directly at:',
];

export const CLASS_NAMES = {
  title:
    'text-14-22-em text-purple-400 md:text-20-24-em mb-3 mt-3 md:mb-6 md:mt-4',
  subtitle: 'text-14-22 text-neutral-600 mb-2',
  contact: 'text-14-22 text-neutral-600 mr-2 whitespace-nowrap',
  contactHours: 'text-14-22 text-neutral-600',
};

export const ICON_PROPS = {
  size: 24,
  stroke: 'neutral-700',
  icon: 'check-circle-color',
};
